import requests from "./httpService";
const GoogleCityAutoCompletion={
    getAllGoogleCityAutocompletions:async(body)=>{
        return requests.post('/googleAutoCompletion/getCityAutoCompletion',body);
    }
}
export default GoogleCityAutoCompletion;